import Axios, { AxiosResponse } from "axios";
import store from "@/store";
import { Configuration } from "@/configuration";
import { DniTrim, toFormData } from "@/utils";
//@ts-ignore
import router from "./router";
import { EventBus } from "./main";


export const ErrorHandler = (res: AxiosResponse, data: any) => {
  return data;
};

Axios.defaults.headers["Content-Type"] = "application/json";

Axios.defaults.headers["X-Requested-With"] = "XMLHttpRequest";

Axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 403 && error.response.data.message.includes('bloqueado')) {
      EventBus.$emit('snack-error','Su cuenta ha sido bloqueada. Por favor, contacte con soporte.');
      
      store.commit("logout");
      store.commit('setBusinessSelected',null)
      router.push({
        path: "/"
      });
    }
    
    return Promise.reject(error);
  }
);

export default {
  async informacion_adicional2(empresa_id:number) {
     const informacion = await Axios.get(`${Configuration.api.base}/cotizacion/informacion_adicional/${empresa_id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
   return informacion.data
  },
  async operacion_factoring(empresa_id:number){
  try {
    const resp = await Axios.get(`${Configuration.api.base}/operacion/factoring/${empresa_id}`,{
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    })
    return resp.data.data;
  } catch (error) {
    return [];
  }
},
async solicitud_factoring(empresa_id:number){
    const resp = await Axios.get(`${Configuration.api.base}/operacion/solicitudes_factoring/${empresa_id}`,{
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    })
   return resp.data;
},
async solicitud_factoringVerDetalle(cotizacion_id:number,empresa_id:number){
  try {
    const resp = await 
    Axios.get(`${Configuration.api.base}/operacion/solicitudes_factoring/detalle/${cotizacion_id}/${empresa_id}`,{
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    })
    return resp.data;
  } 
  catch (error) {
  }
},
  getlanding(query: any){
    return new Promise((resolve, reject) => {
      fetch(`${Configuration.api.landing}${query}`)
      .then(response => resolve(response.json()))
      .catch( (err: any) => {
        reject(err)
      })
     /* Axios.get(`${Configuration.api.landing}${query}`
      ).then( (res: any) => {
        resolve(res)
      }).catch( (err: any) => {
        reject(err)
      })*/
    });
  },
  admin: {
    getAllUsers() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(`${Configuration.api.base}/usuario`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        })
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    loginBypass(id: any) {
      return new Promise((resolve, reject) => {
        Axios.post(
          `${Configuration.api.base}/bypassLogin/${id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            resolve(res.data.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  login(rut: string, password: string) {
    return new Promise((resolve, reject) => {
      Axios.post(`${Configuration.api.base}/login`, {
        rut: DniTrim.string(rut),
        password: password
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          const status = error.response.status;
          if(status === 401){
            reject({ status: 401, message: 'Cuenta bloqueada'});
          }
          else{
            reject(null);
          }
        });
    });
  },
  register(
    token:any,
    nombre: string,
    app_pat: string,
    email: string,
    password: string,
    c_password: string,
    dni: string,
    via_id:number,
    telefono?: string,
    user_tipo_id?: number,
    app_mat?: string,
  ) {
    return new Promise((resolve, reject) => {
      Axios.post(`${Configuration.api.base}/register`, {
        "g-recaptcha-response" : token,
        nombre: nombre,
        app_pat: app_pat,
        email: email,
        password: password,
        c_password: c_password,
        rut: DniTrim.string(dni),
        via_id: via_id,
        telefono: telefono,
        user_tipo_id: user_tipo_id,
        app_mat: app_mat
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  logout() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/logout`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getBanks() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/banco`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getAccountTypes() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/bancos/tipos`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getCompany(companyId: number) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/empresa/${companyId}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getCountries() {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/pais`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getRegions(countryId?: number) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/region`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          if (countryId == undefined) {
            resolve(res.data.data);
          } else {
            resolve(res.data.data.filter((el: any) => el.pais_id == countryId));
          }
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getCommunes(regionId: number) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/comuna/region/${regionId}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  async listar_clasificaciones(){
    const listar_clasificaciones =await Axios.get(`${Configuration.api.base}/listar_clasificaciones`,
    { 
      headers: { 
        Authorization: `Bearer ${store.state.token}`
      } 
    })
    return listar_clasificaciones.data
  },
  async getClasificacion(id:any){
    const getClasificacion =await Axios.get(`${Configuration.api.base}/getClasificacion/${id}`,
    {
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    })
    return getClasificacion.data
  },
  contact(token: string, name: string, mail: string, telefono: string, message: string, clasificacion_id? : number, dato_adicional? :any, origen_reclamo?:any) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/contacto`,
        {
          nombre: name,
          mail: mail,
          telefono,
          mensaje: message,
          clasificacion_id,
          dato_adicional,
          origen_reclamo,
          "g-recaptcha-response" : token
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          resolve(error.response.data);
        });
    });
  },
  recover(token:string,rut: string) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/password/create`,
        {
          "g-recaptcha-response":token,
          rut
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  newPassword(
    rut: string,
    password: string,
    c_password: string,
    token: string
  ) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/password/reset`,
        {
          rut: DniTrim.string(rut),
          password: password,
          c_password: c_password,
          token: token,
        },
        {
          headers: {}
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  createBusiness(payload: any) {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.post(`${Configuration.api.base}/empresa`, payload, {
        headers: {
          "Content-Type": "application/json",
          // 'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${store.state.token}`
        }
        /* onUploadProgress: callback, */
      })
        .then((res: any) => {
          resolve(res.data.data);
        })
        .catch((error: any) => {
          reject(error.response);
        });
    });
  },
  stateBusiness(empresa_id:any){
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/empresa_estado/${empresa_id}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editCompany(company: any) {
    return new Promise((resolve, reject) => {
      let excludes = [
        "id",
        "ejecutivo_id",
        "credito_venta_id",
        "imagen_id",
        "fecha_creacion",
        "deuda",
        "afecto_iva",
        "carpeta"
      ];

      let payload: any = {};

      for (let key in company) {
        if (key.endsWith("ed_at") || excludes.includes(key)) continue;

        payload[key] = company[key];
      }

      Axios.put(`${Configuration.api.base}/empresa/${company.id}`, payload, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(true);
        })
        .catch(error => {
          reject(false);
        });
    });
  },
  async detalle_cuotas(){
    /* let detalle_cuotas = await Axios.get(`${Configuration.api.base}/detalle_cuotas`,{
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    })
    return detalle_cuotas.data */
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/detalle_cuotas`,{
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      }).then(res => {
        let detalle_cuotas: Array<any> = res.data.data;
        resolve(detalle_cuotas);
      }).catch(error => {
        reject([]);
      })
    })

  },
  documents: {
    contracts() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/documentos/${store.state.user.id}/contratos`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            if (res.data.errors != undefined) {
              resolve([]);
            } else {
              resolve(res.data.data.contratos);
            }
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    
    terms() {
      return new Promise((resolve, reject) => {
        // @ts-ignore
        Axios.get(
          // @ts-ignore
          `${Configuration.api.base}/documentos/${store.state.user.id}/mandatos`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        )
          .then(res => {
            if (res.data.errors != undefined) {
              resolve([]);
            } else {
              resolve(res.data.data.contratos);
            }
          })
          .catch(error => {
            reject(null);
          });
      });
    }
    // Fase 16 cleanup: API.documents.ious() eliminado. El modulo Pagare
    // fue deprecado en el backend (sesion 2026-04-28). El endpoint
    // /documentos/{user_id}/pagares no esta registrado en routes/api.php.
  },
  updatePersonalData(user: any) {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.put(
        // @ts-ignore
        `${Configuration.api.base}/usuario/${store.state.user.id}`,
        user,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getPersonalData(userId: number) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/usuario/${userId}`, {
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changePassword(
    oldPassword: string,
    newPassword: string,
    confirmPassword: string
  ) {
    return new Promise((resolve, reject) => {
      Axios.post(
        `${Configuration.api.base}/usuario/password`,
        {
          password: oldPassword,
          password_new: newPassword,
          password_c: confirmPassword
        },
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getBusiness() {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/empresa/usuario/${store.state.user.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data.empresas);
        })
        .catch(error => {
          reject(null);
        });
    });
  },
  getBusiness2(user_id:any) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/empresa/usuario/${user_id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data.empresas);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  accion: {
    uploadImages( user_id: any, empresa_id: any, images: any){
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append('user_id', user_id);
        formData.append('empresa_id', empresa_id);

        images.map((foto: any) => {
          formData.append('imagenes[]', foto, foto.name);
        });

        Axios.post(
          `${Configuration.api.base}/respaldo_empresa`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`
            }
          }
        ).then(res => {
          resolve(res);
        }).catch(error => {
          resolve(error);
        })
      })
    }
  },
  factoring: {
    sii(businesSelected_id:any,password:any,c_password:any){
      return new Promise((resolve,reject)=>{
        Axios.post(`${Configuration.api.base}/sii-configurations/${businesSelected_id}/password`,{
          password: password,
          password_confirmation: c_password,
        },{
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        })
        .then((res)=>{
          resolve(res)
        })
        .catch((err)=>{
          reject(err)
        })
      })
    },
    certificado_sii(businesSelected_id:any,archivo:any,c_password:any){
      return new Promise((resolve,reject)=>{
        let formData = new FormData();
        archivo.forEach((f:any) => {
          formData.append('original', f);
        });
        formData.append('password', c_password);
        Axios.post(`${Configuration.api.base}/empresas/${businesSelected_id}/certificadosDigitales/upload`,
         formData
        ,
          { 
            headers: { 
              Authorization: `Bearer ${store.state.token}`,
              'Content-Type': 'multipart/form-data'
            } 
          }
        )
        .then((res)=>{
          resolve(res)
        })
        .catch((err)=>{
          reject(err)
        })
      })
    },
    factureUploads(businesSelected_id:any,archivo:any){
      return new Promise((resolve,reject)=>{
        let formData = new FormData();
        archivo.forEach((el: any)=>{
          formData.append('xml[]',el)
        })
        Axios.post(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas/upload`,
        formData
        ,
          { 
            headers: { 
              Authorization: `Bearer ${store.state.token}`,
              'Content-Type': 'multipart/form-data'

            } 
          }
        )
        .then((res)=>{
          resolve(res)
        })
        .catch((err)=>{
          reject(err)
        })
      })
    },
    cederFacture(businesSelected_id:any,id_factura:any){
      return new Promise((resolve,reject)=>{
        Axios.post(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas/${id_factura}/ceder`, {},
        { 
          headers: { 
            Authorization: `Bearer ${store.state.token}`
          } 
        }
        ).then((res)=>{
          resolve(res)
        }).catch((err)=>{
          reject(err)
        })
      })
    },
    async cederFacturasMasivo(businesSelected_id:any,facturas:any){
      const ceder = await Axios.post(`${Configuration.api.base}/ceder_masivo/${businesSelected_id}`, 
        {facturas},
        { 
          headers: { 
            Authorization: `Bearer ${store.state.token}`
          } 
        }
      );
      return ceder.data;
    },
    async listarFacturasParaCeder(businesSelected_id:any){
      const listado_faturas = await Axios.get(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas/ceder`, 
        { 
          headers: { 
            Authorization: `Bearer ${store.state.token}`
          } 
        }
      );
      return listado_faturas.data;
    },
    listarFacturasCargadas(businesSelected_id:any){
      return new Promise((resolve,reject)=>{
        Axios.get(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas`,{
           headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }).then((res)=>{
          resolve(res)
        })
        .catch((err)=>{
          reject(err)
        })
      })
    },
    listarFacturasCargadasFiltradas(businesSelected_id:any){
      return new Promise((resolve,reject)=>{
        Axios.get(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas/filtradas`,{
           headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }).then((res)=>{
          resolve(res)
        })
        .catch((err)=>{
          reject(err)
        })
      })
    },
    cargarFactura(businesSelected_id:any,formData:any){
      return new Promise((resolve,reject)=>{
        Axios.post(`${Configuration.api.base}/empresas/${businesSelected_id}/facturasSubidas/upload`, formData,
        { headers: {
          Authorization: `Bearer ${store.state.token}`,
          "X-Requested-With": "XMLHttpRequest",
        }, }
        ).then((res)=>{
          resolve(res)
        }).catch((err)=>{
          reject(err)
        })
      })
    },
    
    sincronizar_emitidos(rut:any){
     return new Promise((resolve,reject)=>{
      Axios.get(`${Configuration.api.base}/sii/${rut}/sincronizar_emitidos`,{
        headers: {
         Authorization: `Bearer ${store.state.token}`
       }
      }).then((res)=>{
        resolve(res)
      })
      .catch((err)=>{
        reject(err)
      })
     })
    },
    // Fase 51 SaaS (reintegración cotización): endpoint consolidado per-tenant.
    // Reemplaza la dupla legacy lista_parametros_cotizacion + date_parametros_onboarding.
    // Requiere auth:api + identify_tenant_api (Bearer + Origin resuelven el tenant).
    // Retorna { error, data: { default_params, onboarding_params } }.
    async tenant_quote_settings(){
      const res = await Axios.get(`${Configuration.api.base}/tenant/quote_settings`,{
        headers: {
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return res.data;
    },
    crear_cotizacion(cotizacion:any){
      return new Promise((resolve,reject)=>{
        Axios.post(`${Configuration.api.base}/crear_cotizacion`, 
          cotizacion,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
        ).then((res)=>{
          resolve(res)
        }).catch((err)=>{
          reject(err)
        })
      })
    },
    verificar_empresa(cotizacion:any){
      return new Promise((resolve,reject)=>{
        Axios.post(`${Configuration.api.base}/verificar_empresa`, 
          cotizacion,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
        ).then((res)=>{
          resolve(res)
        }).catch((err)=>{
          reject(err)
        })
      })
    },
    async get_notificaciones(){
      const info_user_notificacion = await Axios.get(`${Configuration.api.base}/info_user_notificacion`,
      {   
        headers :{
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return info_user_notificacion;
    },
    async get_cuentas(id_empresa:any){
      const listar_mis_cuentas = await Axios.get(`${Configuration.api.base}/listar_mis_cuentas`, 
      {
        params:{
          empresa_id:id_empresa
        },
        headers :{
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return listar_mis_cuentas.data;
    },
    async get_cuenta_sii(dni:any){
       const cuenta_sii = await Axios.get(`${Configuration.api.base}/obtener_cuenta_sii`,
      { params:{
          rut:dni
        },
        headers :{
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return cuenta_sii;
    },
    async get_cuenta_previred(dni:any){
      const cuenta_previred = await Axios.get(`${Configuration.api.base}/obtener_cuenta_previred`,
     {  
       params:{
        rut:dni
      },
       headers :{
         Authorization: `Bearer ${store.state.token}`
       }
     })
     return cuenta_previred;
    },
    async get_cuenta_tgr(dni:any){
      const obtener_cuenta_tgr = await Axios.get(`${Configuration.api.base}/obtener_cuenta_tgr`,
      { 
        params:{
        rut:dni
      },
        headers :{
          Authorization: `Bearer ${store.state.token}`
        }
      })
      return obtener_cuenta_tgr;
    },
    async guardar_cuenta_tgr(dni:any,clave_tgr:any){
      const guardar_cuenta_tgr = await Axios.post(`${Configuration.api.base}/agregar_cuenta_tgr`,
      {
        "rut":dni,
        "clave": clave_tgr
      },
      {
        headers: {
        Authorization: `Bearer ${store.state.token}`
      }
      })
      return guardar_cuenta_tgr.data
    },
    async guardar_cuenta_previred(dni:any,clave_tgr:any){
      const agregar_cuenta_previred = await Axios.post(`${Configuration.api.base}/agregar_cuenta_previred`,
      {
        "rut":dni,
        "clave": clave_tgr
      },
      {
        headers: {
        Authorization: `Bearer ${store.state.token}`
      }
      })
      return agregar_cuenta_previred.data
    },
    async guardar_actualizar_notificacion(mail:any,whatsapp:any,news:any){
      const actualizar_notificacion = await Axios.post(`${Configuration.api.base}/actualizar_notificacion`,
      {
        "whatsapp": whatsapp,
        "news": news,
        "mail": mail
      },
      {
        headers: {
        Authorization: `Bearer ${store.state.token}`
      }
      })
      return actualizar_notificacion.data
    },
    async guardar_cuenta_banco(cuenta:any){
      const cuenta_banco = await Axios.post(`${Configuration.api.base}/crear_cuenta_bancaria_usuario`,
      {
        "banco_id": cuenta.banco_id,
        "cuenta_tipo_id":cuenta.tipo_id,
        "numero": cuenta.numero,
        "empresa_id": cuenta.empresa_id,
        "alias": cuenta.alias
      },
      {
        headers: {
        Authorization: `Bearer ${store.state.token}`
      }
      })
      return cuenta_banco.data
    }, 
    async actualizar_cuenta_bancaria(cuenta:any){
        const actualizar_cuenta_bancaria_usuario = await Axios.put(`${Configuration.api.base}/actualizar_cuenta_bancaria_usuario`,
        {
          "cuenta_id": cuenta.cuenta_id,
          "banco_id": cuenta.banco_id,
          "cuenta_tipo_id": cuenta.tipo_id,
          "numero": cuenta.numero,
          "empresa_id": cuenta.empresa_id,
          "alias": cuenta.alias
        },
        {
          headers: {
          Authorization: `Bearer ${store.state.token}`
        }
        })
        return actualizar_cuenta_bancaria_usuario.data
    },
    async factura_subir_pdf(empresa_id:any,id_factura:any,file_pdf:any){
      let formData = new FormData();
      formData.append('archivo',file_pdf)
      formData.append('id',id_factura)
      const pdf = await Axios.post(`${Configuration.api.base}/empresas/${empresa_id}/facturasSubidas/subir_respaldo_factura`,
      formData,
      { 
        headers: { 
          Authorization: `Bearer ${store.state.token}`,
          'Content-Type': 'multipart/form-data'
        } 
      })
      return pdf.data
    },
    async actualizar_estados_factura(empresa_id:any,id_factura:any,id_estado:any){
      const actualizar_estados_factura = await Axios.post(`${Configuration.api.base}/empresas/${empresa_id}/facturasSubidas/actualizar_estado_factura`,
      {
        id:id_factura,
        id_estado
      },
      { 
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return actualizar_estados_factura.data
    },
    async actualizarFechaVencimiento(empresa_id:any,facturas:any){
      const actualizar_fecha_vencimiento = await Axios.post(`${Configuration.api.base}/empresas/${empresa_id}/facturasSubidas/actualizar_fecha_vencimiento`,
      {
        facturas
      },
      { 
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return actualizar_fecha_vencimiento;
    },
    async ultimoPasoEmpresa(empresa_id:any,origen:any){
      const {data} = await Axios.get(`${Configuration.api.base}/track/onboarding/${empresa_id}/${origen}`,
      {
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return data;
    },
    async tranckingOnboarding(origen:any,empresa_id:any,ip_address:any,variable:any,info?:any,facturas?:any){
      const tranckingOnboarding = await Axios.post(`${Configuration.api.base}/track/onboarding`,
      {
        origen,
        empresa_id,
        ip_address,
        variable,
        info,
        facturas
      },
      { 
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return tranckingOnboarding.data
    },
    async listar_facturas_onboarding(empresa_id:any){
      const {data} = await Axios.get(`${Configuration.api.base}/listar_facturas_onboarding/${empresa_id}`,
      {
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return data;
    },
    async obtenerCertificado(empresa_id:any){
      const data = await Axios.get(`${Configuration.api.base}/empresas/${empresa_id}/certificadoDigital`,
      {
        headers: { Authorization : `Bearer ${store.state.token}`}
      })
      return data

    }, 
    async descargarPdf(empresa_id:any,documento_id:any) {
      const data = await Axios.get(`${Configuration.api.base}/descargar_pdf/${empresa_id}/${documento_id}`,
      {
        headers: { Authorization : `Bearer ${store.state.token}`},
        responseType: 'blob'
      })
      return data
    },
    async sii_vinculado(empresa_id:any){
      const data = await Axios.get(`${Configuration.api.base}/empresas/${empresa_id}/sii`,
      {
        headers: { Authorization : `Bearer ${store.state.token}`},
      })
      return data.data
    },
    async simularCotizacion(simulacion:any){
      const simular_cotizacion =await Axios.post(`${Configuration.api.base}/simular_cotizacion_onboarding`,
        simulacion,
      { 
        headers: { 
          Authorization: `Bearer ${store.state.token}`
        } 
      })
      return simular_cotizacion.data
    },
    async subir_respaldo_cotizacion(formData: any){
      const respaldo = await Axios.post(`${Configuration.api.base}/subir_respaldo_cotizacion`, 
       formData,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
            'Content-Type': 'multipart/form-data'
          }
        })
      return respaldo.data
    },
    async solicitar_pago_excedente(formData:any){
      const pago_excendente = await Axios.post(`${Configuration.api.base}/operacion/factoring/excedentes`,
      formData
      ,
       {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
          'Content-Type': 'multipart/form-data'
        }
       })
       return pago_excendente.data
    },
    async sumaFacturas(empresa_id:any){
      const sumaFacturas = await Axios.get(`${Configuration.api.base}/suma_facturas_dte/${empresa_id}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return sumaFacturas.data
    },
    async listarFacturasDTE(empresa_id:any){
      const facturasDte = await Axios.get(`${Configuration.api.base}/listar_facturas_dte/${empresa_id}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return facturasDte.data
    },

    async datosResumen(empresa_id:any){
      var formData = new FormData()
      formData.append("empresa_id",empresa_id);
      const resp = await Axios.post(`${Configuration.api.base}/data_empresa/resumen`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return resp.data;
    },
    async datosInstituciones(empresa_id:any){
      var formData = new FormData()
      formData.append("empresa_id",empresa_id);
      const resp = await Axios.post(`${Configuration.api.base}/data_empresa/instituciones`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return resp.data;
    },
    async datosVentas(empresa_id:any){
      var formData = new FormData()
      formData.append("empresa_id",empresa_id);
      const resp = await Axios.post(`${Configuration.api.base}/data_empresa/ventas`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return resp.data;
    },
    async datosNotasCredito(empresa_id:any){
      var formData = new FormData()
      formData.append("empresa_id",empresa_id);
      const resp = await Axios.post(`${Configuration.api.base}/data_empresa/notas_credito`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return resp.data;
    },
    async listarFacturasConfirming(empresa_id:number){
      const facturasConfirming = await Axios.get(`${Configuration.api.base}/listar_facturas_dte_confirming/${empresa_id}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return facturasConfirming.data;

    },
    async datosPoderJudicial(rut_empresa:any){
      const data_poderJudicial = await Axios.get(`${Configuration.api.base}/data_pjud/${rut_empresa}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return data_poderJudicial.data;
    },
    async datosConvenios(rut_empresa:any){
      const datosConvenios = await Axios.get(`${Configuration.api.base}/data_convenios/${rut_empresa}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return datosConvenios.data;
    },
    async datosGraficos(rut_empresa:any){
      const datosGraficos = await Axios.get(`${Configuration.api.base}/data_grafo/${rut_empresa}`,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      })
      return datosGraficos.data;
    }
	},
    // Validaciones Clave SII
	validarTokenEmpresa(token: any){
		return new Promise((resolve,reject)=>{
			Axios.post(`${Configuration.api.base}/validar_token_empresa`, {token: token}).
			then( res =>{
				resolve(res.data)
			}).catch( err=>{
				reject(err)
			})
		})
	},
	cambiarClaveSii(formData: any){
		return new Promise(( resolve, reject ) =>{
			Axios.post(`${Configuration.api.base}/cambiar_clave_sii`, formData).
			then( res => {
				resolve(res)
			}).catch( err => {
				reject(err)
			})
		})
	},
	// Landing pública de enrolamiento: vincula la clave SII de la empresa.
	// El tenant lo resuelve el backend por dominio (Origin/Referer/Host) — el
	// frontend NO manda tenant id. Payload: { rut, clavesii, email, terminos,
	// 'g-recaptcha-response'? }.
	registroClaveSiiLanding(formData: any){
		return new Promise(( resolve, reject ) =>{
			Axios.post(`${Configuration.api.base}/landing/registro-clave-sii`, formData).
			then( res => {
				resolve(res)
			}).catch( err => {
				reject(err)
			})
		})
	},
	// Landing de enrolamiento: valida el token de invitación (vigencia/uso) y que
	// la empresa pertenezca al tenant. Respuesta makeJson: { data: { rut_empresa } }.
	validarTokenEnrolamiento(token: string){
		return new Promise(( resolve, reject ) =>{
			Axios.post(`${Configuration.api.base}/landing/validar-token-enrolamiento`, { token }).
			then( res => {
				resolve(res)
			}).catch( err => {
				reject(err)
			})
		})
	},

  getPasswordRules(){
    return Axios.get(`${Configuration.api.base}/password_rules`);
  },

  //se encarga de mandar el rut encriptado y devolver la info de la empresa consultada
  getEncryptedCompany(rut_empresa:string, token: string){
    const formData = new FormData();
    formData.append('rut_empresa', rut_empresa);
    formData.append('token', token);

    return Axios.post(`${Configuration.api.base}/obtenerRutEmpresa`, formData);
  },

  vincularEmpresaUsuario(empresa_id:any, user_id:any){
    const formData = new FormData();
    formData.append('empresa_id', empresa_id);
    formData.append('user_id', user_id);

    return Axios.post(`${Configuration.api.base}/vincularEmpresaUsuario`, formData);
  },

  empresaVinculada(empresa_id: string, user_id: string, password:string){
    const formData = new FormData();
    formData.append('empresa_id', empresa_id);
    formData.append('user_id', user_id);
    formData.append('password_sii', password);

    return Axios.post(`${Configuration.api.base}/vincular-empresa`, formData, {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    });
  },
  getStatusServer() {
    return new Promise((resolve, reject) => {
      Axios.get(
        `${Configuration.api.status_aws}?x-api-key=VKe5pNp2qG5K9JvJG5P07aYq8NKE71BA3ehbNIiu&server_id=1`,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
        .then((res: any) => {
          resolve(res);
        })
        .catch((error: any) => {
          reject(error.response);
        });
    });
  },

  async getDataEmpresaWarren(rut:string, token:string) {
    const formData = new FormData();
    formData.append('rut_empresa', rut);
    formData.append('token', token);
  
    const response = await fetch(`${Configuration.api.dte_chile}/validarDatos`, {
      method: 'POST',
      body: formData
    });
  
    const data = await response.json();
    return { 
      status: response.status, 
      data: data.data 
    };
  },


  async getDataVerificacionFacturas(verificacion_encrypt:string) {
    try {
      const formData = new FormData();
      formData.append('data', verificacion_encrypt);
  
      const response = await Axios.post(`${Configuration.api.base}/obtener_datos_verificacion`, formData);
      return {
        status: response.status,
        data: response.data.data
      };
    } catch (error) {
      return { status: 500, data: null };
    }
  },
  
  async enviarRespuestasVerificacion(verificacion_encrypt:string, respuestas:any) {
    
    try {
      const formData = new FormData();
      formData.append('data', verificacion_encrypt);
      formData.append('respuestas', respuestas);
  
      const response = await Axios.post(`${Configuration.api.base}/enviar_verificacion`, formData);
      return {
        status: response.status,
        data: response.data.data
      };
    } catch (error) {
      return { status: 500, data: null };
    }
  },

  sincronizarIngresoRegistro(qrcode:string, ip: string) {
    
      const formData = new FormData();
      formData.append('qrcode', qrcode);
      formData.append('ipGuest', ip);
      const response = Axios.post(`${Configuration.api.base}/capturaqr`, formData);
      
      return response;
  },

  async paginaMantencion(){
    const data = await Axios.get(`${Configuration.api.base}/pagina_mantencion`,
    {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      }
    })
    return data.data
  },

  async obtenerLiquidacionCotizacion(cotizacion_id:number){
    const resp = await Axios.get(`${Configuration.api.base}/operacion/obtener_liquidacion/${cotizacion_id}`,{
      headers: {
          Authorization: `Bearer ${store.state.token}`,
          Accept: 'application/pdf'
      },
      responseType: 'blob'
    });

    return resp;
  },
  getCobranzas(empresa_id:number) {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      Axios.get(
        // @ts-ignore
        `${Configuration.api.base}/cobranza/${empresa_id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data);
        })
        .catch(error => {
          reject(null);
        });
    });
  },

  async generatePDF(payload:any){
    const formData = new FormData();
    formData.append('payload', JSON.stringify(payload));

    const response = await Axios.post(`${Configuration.api.base}/documento/generar`, formData, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${store.state.token}`,
        Accept: 'application/pdf',
      }
    });

    return response;
  },

  // Wizard de compliance / evaluacion BCI (reactivado). Endpoints re-registrados
  // en el backend (routes/api.php, grupo tenantizado auth:api + identify_tenant_api).
  getInfoSII() {
    return Axios.get(`${Configuration.api.base}/form_bci/recursos_sii`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });
  },
  guardarFormBCI(empresa_id: string, payload: any) {
    return Axios.post(`${Configuration.api.base}/form_bci/guardar_formulario`,
      {
        empresa_id: empresa_id,
        ...payload
      },
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  },
  sendInfoEmpresa(payload: any) {
    const formData = new FormData();
    formData.append('rut_empresa', payload.rut);
    formData.append('nombre_empresa', payload.r_social);
    formData.append('password_sii', payload.password);

    return Axios.post(`${Configuration.api.base}/form_bci/guardar_empresa`, formData,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  },
  terminarEvaluacion(empresa_id: any) {
    const formData = new FormData();
    formData.append('empresa_id', empresa_id);
    return Axios.post(`${Configuration.api.base}/form_bci/evaluacion_terminada`, formData,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  },
  obtenerRepresentantes(id: number) {
    return Axios.get(`${Configuration.api.base}/form_bci/obtener_representantes/${id}`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });
  },
  getBusinessFormBCI(user_id: any) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Configuration.api.base}/form_bci/empresas_usuario/${user_id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`
          }
        }
      )
        .then(res => {
          resolve(res.data.data.empresas);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  guardarProgreso(empresa_id: any, step_form: any) {
    const formData = new FormData();
    formData.append('empresa_id', empresa_id);
    formData.append('step_form', step_form);
    return Axios.post(`${Configuration.api.base}/form_bci/guardar_progreso`, formData,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  },
  updGiro(empresa_id: any, giro: any, rubro_economico: any) {
    const formData = new FormData();
    formData.append('empresa_id', empresa_id);
    formData.append('giro', giro);
    formData.append('rubro_economico', rubro_economico);
    return Axios.post(`${Configuration.api.base}/form_bci/actualizar_giro`, formData,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  },
  obtenerDireccionEmpresaSII(empresa_id: any) {
    const formData = new FormData();
    formData.append('empresa_id', empresa_id);
    return Axios.post(`${Configuration.api.base}/form_bci/obtenerDireccionEmpresa`, formData,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        }
      });
  },
  obtenerSocios(id: number) {
    return Axios.get(`${Configuration.api.base}/form_bci/obtener_socios/${id}`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });
  },
  // RC-3727: lista de empresas Tradicionales finalizadas que requieren re-confirmacion de socios
  async getEmpresasConfirmacionParticipacion() {
    const resp = await Axios.get(`${Configuration.api.base}/form_bci/confirmacion_participacion/empresas`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });
    return resp.data;
  },
  // RC-3727: detalle/elegibilidad de re-confirmacion de una empresa especifica
  async getDetalleConfirmacionParticipacion(empresa_id: number) {
    if (!Number.isInteger(empresa_id) || empresa_id <= 0) {
      return { status: 0, message: 'empresa_id invalido' };
    }
    const resp = await Axios.get(`${Configuration.api.base}/form_bci/confirmacion_participacion/empresas/${empresa_id}`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });
    return resp.data;
  },
  // RC-3727: confirmar participacion de socios + subir libro de accionistas (re-confirmacion)
  async confirmarParticipacionSocios(empresa_id: number, socios: any[], libro_accionistas: File, onUploadProgress?: (percent: number, loaded: number) => void) {
    if (!Number.isInteger(empresa_id) || empresa_id <= 0) {
      return { status: 0, message: 'empresa_id invalido' };
    }
    const formData = new FormData();
    formData.append('socios', JSON.stringify(socios));
    formData.append('libro_accionistas', libro_accionistas);
    formData.append('confirmation_mode', 'traditional_active_document_shareholders');
    const resp = await Axios.post(
      `${Configuration.api.base}/form_bci/confirmar_participacion_socios/${empresa_id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: onUploadProgress ? (e: any) => {
          const percent = e.total ? Math.round((e.loaded * 100) / e.total) : 0;
          onUploadProgress(percent, e.loaded);
        } : undefined
      }
    );
    return resp.data;
  },
  // RC-3728: estado de clasificacion TEEUD/Tradicional de una empresa en onboarding
  async getEstadoClasificacion(empresa_id: number) {
    if (!Number.isInteger(empresa_id) || empresa_id <= 0) {
      return { status: 0, message: 'empresa_id invalido' };
    }
    const resp = await Axios.get(
      `${Configuration.api.base}/form_bci/estado_clasificacion/${empresa_id}`,
      { headers: { Authorization: `Bearer ${store.state.token}` } }
    );
    return resp.data;
  },
  // RC-3728: registrar libro de accionistas durante el onboarding inicial (empresas Tradicional)
  async registrarLibroAccionistasOnboarding(
    empresa_id: number,
    libro_accionistas: File,
    onUploadProgress?: (percent: number, loaded: number) => void
  ) {
    if (!Number.isInteger(empresa_id) || empresa_id <= 0) {
      return { status: 0, message: 'empresa_id invalido' };
    }
    const formData = new FormData();
    formData.append('libro_accionistas', libro_accionistas);
    const resp = await Axios.post(
      `${Configuration.api.base}/form_bci/onboarding/registrar_libro_accionistas/${empresa_id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: onUploadProgress
          ? (e: any) => {
              const percent = e.total ? Math.round((e.loaded * 100) / e.total) : 0;
              onUploadProgress(percent, e.loaded);
            }
          : undefined,
      }
    );
    return resp.data;
  },
  obtenerPaises() {
    return Axios.get(`${Configuration.api.base}/form_bci/paises`, {
      headers: {
        Authorization: `Bearer ${store.state.token}`
      }
    });
  },
};
